export function post(url, body) {
    return new Promise(function(resolve, reject) {
        generateXmlHttpRequest(resolve, reject, 'POST', url, true, body);
    });
}

export function get(url) {
    return new Promise(function(resolve, reject) {
        generateXmlHttpRequest(resolve, reject, 'GET', url, true, null, resolve, reject);
    });
}

function generateXmlHttpRequest(resolve, reject, method, url, async, body) {
    const xhttp = new XMLHttpRequest();
    xhttp.open("POST", url, async);
    xhttp.withCredentials = true;
    xhttp.send(body || null);

    xhttp.onload = function() {
        if (xhttp.readyState == 4) {
            if (xhttp.status == 200) {
                resolve(xhttp.responseText)
            } else {
                reject();
            }
        }
    };

    xhttp.onerror = function() {
        reject(xhttp);
    }
}
